import React from "react";
import CurtainsClosedOutlinedIcon from "@mui/icons-material/CurtainsClosedOutlined";
import { useNavigate } from "react-router-dom";
import { hitCreateProfileApi } from "../../../Redux/Professional/CreateProfileSlice";
import { hitGetProfileApi } from "../../../Redux/Professional/GetProfileSlice";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { showToast } from "../../../Helper/Toast";
import arrowDown from "../../../assets/img/downIcon11.svg";
import iconoir_suitcase from "../../../assets/img/iconoir_suitcase.svg";
import verify from "../../../assets/img/Verify img green.svg";
import Identityverification from "../../../assets/img/Identity verification 1.svg";

const SignUpStepTwo = () => {
  const navigate = useNavigate();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [professionalData, setProfessionalData] = useState(null);

  const [formData, setFormData] = useState({
    professionalField: "",
    companyPosition: "",
    website: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const storedData = localStorage.getItem("professionalToken");
    if (storedData) {
      fetchProfessionalData();
    }
  }, []);

  const fetchProfessionalData = async () => {
    try {
      const response = await dispatch(hitGetProfileApi());
      setProfessionalData(response.payload.data);
    } catch (error) {
      console.error("Error fetching professional data:", error);
    }
  };

  const isValidFormData =
    formData.professionalField.trim() !== "" &&
    formData.companyPosition.trim() !== "";

  useEffect(() => {
    if (professionalData) {
      setFormData((prev) => ({
        ...prev,
        professionalField: professionalData.professionalField || "",
        companyPosition: professionalData.companyPosition || "",
        website: professionalData.website || "",
      }));
    }
  }, [professionalData]);

  const submitSecondStep = async (e) => {
    e.preventDefault(); // 👈 stop page refresh
    try {
      formData.profileSteps = 2;
      const response = await dispatch(hitCreateProfileApi(formData));
      //console.log("Response from create profile API:", response);
      if (response.payload.status === true) {
        navigation("/professional/signup-three");
      } else {
        showToast(response.payload.message, "error");
      }
    } catch (error) {
      console.error("Error sending verification code:", error);
    }
  };

  return (
    <div className="custom_container pro-signup-page">
      <div className="business-form">
        {/* Header */}
        <div
          className="bussiness-form-header-top"
          style={{ background: "#f1f7fd" }}
        >
          <div className="business-form__header">
            <div
              className="business-form__step"
              style={{ alignItems: "center" }}
            >
              <span
                className="business-form__step-badge"
                style={{
                  background:
                    "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                }}
              >
                2
              </span>
              <div>
                <span className="title_head" style={{ color: "#cc4645" }}>
                  Business Details
                </span>
              </div>
            </div>
            <p className="business-form__exit">2/4</p>
          </div>
          <div
            className="progress-bar-container"
            style={{ background: "#edf0f3" }}
          >
            <div
              className="progress-bar-fill"
              style={{
                width: "75%",
                background: "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
              }}
            ></div>
          </div>
          <p
            className="business-form__step__number mb-0"
            style={{
              background: "#fff",
              color: "#6a7280",
              fontWeight: "500",
              padding: "6px 12px",
              marginTop: 10,
            }}
          >
            Step 2 of 4
          </p>
        </div>

        {/* Title */}
        <div className="business-form__title">
          <div className="company_info">
            <p>
              <img src={iconoir_suitcase} alt="Business Information" />
              <span>Business Information</span>
            </p>
          </div>
          <h2>Tell us about your Business</h2>
          <p>
            Company information to build trust with
            <br />
            clients and help you get verified.
          </p>
        </div>

        {/* Form */}
        <form>
          <div>
            <label>Professional Field</label>
            <select
              value={formData.professionalField}
              onChange={handleChange}
              name="professionalField"
              className="w-100"
              style={{
                paddingRight: "40px",
                backgroundImage: `url(${arrowDown})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 10px center",
                backgroundSize: "20px ",
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
              }}
            >
              <option>Select your field</option>
              <option value="General Contractor">General Contractor</option>
              <option value="Handyman">Handyman</option>
              <option value="Flooring Installer">Flooring Installer</option>
              <option value="Artificial Grass Installer">
                Artificial Grass Installer
              </option>
              <option value="Landscaper / Hardscape Pro">
                Landscaper / Hardscape Pro
              </option>
              <option value="Concrete Contractor">Concrete Contractor</option>
              <option value="Paver Installer">Paver Installer</option>
              <option value="Garage Renovation Specialist">
                Garage Renovation Specialist
              </option>
              <option value="Finish Carpenter">Finish Carpenter</option>
              <option value="Cabinet Maker / Installer">
                Cabinet Maker / Installer
              </option>
              <option value="Closet System Installer">
                Closet System Installer
              </option>
              <option value="Bathroom Remodeler">Bathroom Remodeler</option>
              <option value="Kitchen Remodeler">Kitchen Remodeler</option>
              <option value="Tile Installer">Tile Installer</option>
              <option value="Painter">Painter</option>
              <option value="Interior Designer">Interior Designer</option>
              <option value="Door & Entryway Installer">
                Door & Entryway Installer
              </option>
              <option value="Roofing Contractor">Roofing Contractor</option>
              <option value="Epoxy Floor Specialist">
                Epoxy Floor Specialist
              </option>
              <option value="Wall Paneling & Wainscoting Pro">
                Wall Paneling & Wainscoting Pro
              </option>
              <option value="Crown Molding Installer">
                Crown Molding Installer
              </option>
              <option value="Lighting & Fixture Installer">
                Lighting & Fixture Installer
              </option>
              <option value="Custom Storage Builder">
                Custom Storage Builder
              </option>
              <option value="Window Installer">Window Installer</option>
              <option value="Door Installer">Door Installer</option>
              <option value="Sod & Surface Prep Specialist">
                Sod & Surface Prep Specialist
              </option>
              <option value="Pool Deck Contractor">Pool Deck Contractor</option>
              <option value="Putting Green Installer">
                Putting Green Installer
              </option>
              <option value="Accent Wall Designer">Accent Wall Designer</option>
              <option value="Vanity & Sink Installer">
                Vanity & Sink Installer
              </option>
              <option value="Masonry / Stonework Specialist">
                Masonry / Stonework Specialist
              </option>
              <option value="Gutter Installation & Repair">
                Gutter Installation & Repair
              </option>
              <option value="Other">Other (please specify)</option>
            </select>
          </div>

          <div>
            <label>Position/Role in Company</label>
            <select
              value={formData.companyPosition}
              onChange={handleChange}
              name="companyPosition"
              className="w-100"
              style={{
                paddingRight: "40px",
                backgroundImage: `url(${arrowDown})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 10px center",
                backgroundSize: "20px ",
                appearance: "none",
                WebkitAppearance: "none",
                MozAppearance: "none",
              }}
            >
              <option>Select your position</option>
              <option value="Owner">Owner</option>
              <option value="CEO">CEO</option>
              <option value="Co-Founder">Co-Founder</option>
              <option value="President">President</option>
              <option value="General Manager">General Manager</option>
              <option value="Sales Manager">Sales Manager</option>
              <option value="Sales Representative">Sales Representative</option>
              <option value="Project Manager">Project Manager</option>
              <option value="Estimator">Estimator</option>
              <option value="Installer / Technician">
                Installer / Technician
              </option>
              <option value="Office Administrator">Office Administrator</option>
              <option value="Operations Manager">Operations Manager</option>
              <option value="Other">Other (please specify)</option>
            </select>
          </div>

          <div>
            <label>Website URL (optional)</label>
            <input
              type="url"
              placeholder="https://yourwebsite.com"
              value={formData.website}
              onChange={handleChange}
              name="website"
              className="w-100"
            />
          </div>

          {/* Verification Box */}
          {/* <div className="verification-box">
            <img src={Identityverification} alt="success" className="mt-1" />

            <div className="verification-box__content">
              <p
                className="verification-title"
                style={{ color: "#000", fontWeight: "bold" }}
              >
                Verify your business after onboarding to unlock your free
                credits!
              </p>
              <p className="verification-text" style={{ color: "#64748b" }}>
                Verifying your company helps us maintain a trusted network of
                professionals. Once approved, you'll receive your free credits
                to start bidding
              </p>
              <p
                className="verification-title"
                style={{ color: "#000", fontWeight: "bold" }}
              >
                Here's whatverification includes:
              </p>
              <ul style={{ color: "#64748b" }}>
                <li>Business email address verification</li>
                <li>Business phone number must be reachable for audit calls</li>
                <li>Accounts & tax docs once approved</li>
              </ul>
            </div>
          </div> */}

          {/* Buttons */}
          <div className="form-actions">
            <button
              type="submit"
              className="next-btn"
              onClick={e => {
                if (!(isValidFormData)) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }
                else {
                  submitSecondStep(e);
                }
              }}
              style={{
                background: isValidFormData === true ? "#b22222" : "#b3b3b3",
                cursor: isValidFormData === false ? "not-allowed" : "pointer",
              }}
            >
              Next →
            </button>
            <div className="d-flex justify-content-center mt-2">
              <button
                type="button"
                className="back-btn"
                onClick={() => navigate("/professional/signup-one")}
              >
                ← Back
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUpStepTwo;
